export default {
    essential: {
      title: 'Essentials',
      code: 'ESSENTIAL',
      limits: [
          {
            id: 'profiles',
            value: "3"
          },
          {
            id: 'customfields',
            value: "10"
          },
          {
            id: 'pipelines',
            value: "2"
          },
          {
            id: 'dunning',
            value: "1"
          },
          {
            id : 'support',
            value: window.i18n.__('Chat en ligne')
          },
          {
            id : 'esign',
            value: '50'
          },
          {
            id : 'email',
            value: '30 000'
          },
          {
            id : 'sms',
            value: '500'
          },
          {
            id : 'mail',
            value: '25'
          },
          {
            id: 'api',
            value: window.i18n.__("≤ 250 K req / jour")
          }
      ],
    },
    advanced: {
      title: 'Advanced',
      code: 'ADVANCED',
      limits: [
          {
            id: 'profiles',
            value: "10"
          },
          {
            id: 'customfields',
            value: "50"
          },
          {
            id: 'pipelines',
            value: "20"
          },
          {
            id: 'dunning',
            value: "3"
          },
          {
            id : 'support',
            value: window.i18n.__('Chat + téléphone')
          },
          {
            id : 'esign',
            value: '200'
          },
          {
            id : 'email',
            value: '120 000'
          },
          {
            id : 'sms',
            value: '2 500'
          },
          {
            id : 'mail',
            value: '100'
          },
          {
            id: 'api',
            value: window.i18n.__("≤ 432 K req / jour")
          }
        ],
      },
    enterprise: {
        title: 'Enterprise',
        code: 'ENTERPRISE',
        limits: [
            {
              id: 'profiles',
              value: window.i18n.__("Illimités")
            },
            {
              id: 'customfields',
              value: window.i18n.__("Illimités")
            },
            {
              id: 'pipelines',
              value: window.i18n.__("Illimités")
            },
            {
              id: 'dunning',
              value: window.i18n.__("Illimité")
            },
            {
              id : 'support',
              value: window.i18n.__('Gestionnaire de compte')
            },
            {
              id : 'esign',
              value: '500'
            },
            {
              id : 'email',
              value: '300 000'
            },
            {
              id : 'sms',
              value: '5 000'
            },
            {
              id : 'mail',
              value: '250'
            },
            {
              id: 'api',
              value: window.i18n.__("≤ 432 K req / jour")
            }
        ],
    }
}